import styled from "styled-components";
const BoxImpl = styled("div")(
  ({ theme }) => ({
    backgroundColor: theme.colors.gray3.hex,
    border: `1px solid ${theme.controlBorderColor}`,
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "relative"
  }),
  ({ $height }) => ({
    height: $height
  }),
  ({ $width }) => ({
    width: $width
  })
);
const BoxInner = styled("div")({
  position: "absolute"
});
export {
  BoxImpl,
  BoxInner
};
